import React from 'react';
import {
  BlueprintSchedulingContextProvider,
  BlueprintSchedulingState,
  BlueprintSchedulingMode,
} from './BlueprintSchedulingContextProvider';
import { TimeSlot } from '../../utils/getBlueprintSlots';

export type BlueprintSchedulingProviderProps = React.PropsWithChildren<{}>;

export const BlueprintSchedulingProvider: React.FC<BlueprintSchedulingProviderProps> = ({
  children,
}) => {
  const [showSchedulingDialog, setShowSchedulingDialog] = React.useState(false);
  const [state, setState] = React.useState<BlueprintSchedulingState>('slot-selection');
  const [selectedSlot, setSelectedSlot] = React.useState<TimeSlot | null>(null);
  const [mode, setMode] = React.useState<BlueprintSchedulingMode>('create');
  const [bookingId, setBookingId] = React.useState<string | null>(null);
  const [isFeedbackFlow, setIsFeedbackFlow] = React.useState<boolean>(false);
  const [selectedTimezone, setSelectedTimezone] = React.useState<string>(
    () => Intl.DateTimeFormat().resolvedOptions().timeZone
  );

  const handleShowSchedulingDialog = React.useCallback((isFeedback = false) => {
    setIsFeedbackFlow(isFeedback);
    setShowSchedulingDialog(true);
    setState('slot-selection');
    setSelectedSlot(null);
    setMode('create');
    setBookingId(null);
  }, []);

  const handleHideSchedulingDialog = React.useCallback(() => {
    setShowSchedulingDialog(false);
    setState('slot-selection');
    setSelectedSlot(null);
    setMode('create');
    setBookingId(null);
    setIsFeedbackFlow(false);
  }, []);

  const handleOpenRescheduleDialog = React.useCallback((id: string) => {
    setBookingId(id);
    setMode('reschedule');
    setState('slot-selection');
    setSelectedSlot(null);
    setShowSchedulingDialog(true);
  }, []);

  return (
    <BlueprintSchedulingContextProvider
      value={{
        showSchedulingDialog,
        setShowSchedulingDialog: handleShowSchedulingDialog,
        setHideSchedulingDialog: handleHideSchedulingDialog,
        state,
        setState,
        selectedSlot,
        setSelectedSlot,
        mode,
        setMode,
        bookingId,
        setBookingId,
        openRescheduleDialog: handleOpenRescheduleDialog,
        selectedTimezone,
        setSelectedTimezone,
        isFeedbackFlow,
        setIsFeedbackFlow,
      }}
    >
      {children}
    </BlueprintSchedulingContextProvider>
  );
};
